import type { ReactElement } from 'react';
import { Activity, Package, Globe } from 'lucide-react';
import { MetricCard } from '@/components/ui/metric-card';

// null = unknown (fetch failed / not loaded); a real 0 renders as 0, not "—".
export function SummaryStats({
  runningCount,
  installedCount,
  browserCount,
  isLoading = false,
}: {
  runningCount: number | null;
  installedCount: number | null;
  browserCount: number | null;
  isLoading?: boolean;
}): ReactElement {
  if (isLoading) {
    return (
      <div className="grid grid-cols-3 gap-5">
        {[...Array(3)].map((_, i) => (
          <div
            key={i}
            className="rounded-lg p-5 animate-pulse bg-white dark:bg-slate-800/40 border border-slate-200 dark:border-slate-700/40"
          >
            <div className="w-9 h-9 rounded-lg bg-slate-100 dark:bg-slate-700/50" />
            <div className="h-8 w-12 rounded bg-slate-100 dark:bg-slate-700/50 mt-3" />
            <div className="h-4 w-24 rounded bg-slate-100 dark:bg-slate-700/50 mt-1" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-5">
      <MetricCard
        variant="info"
        icon={Activity}
        label="Running Now"
        value={runningCount ?? '—'}
      />
      <MetricCard
        variant="neutral"
        icon={Package}
        label="Installed Tools"
        value={installedCount ?? '—'}
      />
      <MetricCard
        variant="neutral"
        icon={Globe}
        label="Browser Activity"
        value={browserCount ?? '—'}
      />
    </div>
  );
}
